import BaseComponent from '../base-component/base-component'
import type Accordeon from './accordeon'

class AccordeonContainer extends BaseComponent {
  tabs: Accordeon[]

  constructor() {
    super()

    this.tabs = [...this.querySelectorAll('accordeon-component')] as Accordeon[]
  }

  connectedCallback(): void {
    this.tabs.forEach(tab => {
      customElements.whenDefined('accordeon-component').then(() => {
        tab.subscribe('toggle', this.handleTabToggle)
      })
    })
  }

  disconnectedCallback(): void {
    this.tabs.forEach(tab => {
      customElements.whenDefined('accordeon-component').then(() => {
        tab.unsubscribe('toggle', this.handleTabToggle)
      })
    })
  }

  handleTabToggle = ({ blockId }: { blockId: string }): void => {
    this.tabs.forEach(tab => {
      if (tab.dataset.blockId !== blockId && tab.isExpanded) {
        tab.hide()
      }
    })
  }
}

export default AccordeonContainer
